import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { Actuality } from "@/savaradio/common"
import { ActualityGroup } from "@/savaradio/common"

export const initialLoading = {
  get: false,
  find: false,
  remove: false,
  update: false,
  create: false,
  upload: false
}
export type IsLoading = Record<keyof typeof initialLoading, boolean>;

const initialState: {
  value?: ActualityGroup[],
  isLoading: IsLoading
} = {
  isLoading: initialLoading
}

const actualitySlice = createSlice({
  name: "actuality_slice",
  initialState,
  reducers: {
    append: (state, action: PayloadAction<Actuality>) => {
      if (!state.value) state.value = [{
        _id: action.payload.when,
        count: 1,
        actualities: [action.payload]
      }]
      else {
        const target_actuality_group = state.value.find(actuality_group => actuality_group._id === action.payload.when)
        if (
          target_actuality_group &&
          !target_actuality_group.actualities.some(item => item._id === action.payload._id)
        ) {
          state.value = state.value.map(actuality_group => {
            if (actuality_group._id === target_actuality_group._id) return {
              ...target_actuality_group,
              count: target_actuality_group.count + 1,
              actualitys: [...target_actuality_group.actualities, action.payload]
            }
            else return actuality_group
          })
        }
        if (!target_actuality_group) {
          state.value = [
            ...state.value,
            {
              _id: action.payload.when!,
              count: 1,
              actualities: [action.payload]
            }
          ]
        }
      }
    },
    pop: (state, action: PayloadAction<Actuality>) => {
      if (state.value) state.value = state.value.map(actuality_group => (
        actuality_group._id === action.payload.when ?
          {
            ...actuality_group,
            actualities: actuality_group.actualities.filter(actuality => actuality._id !== action.payload._id),
            count: actuality_group.count - 1
          }
          :
          actuality_group
      ))
    },
    merge: (state, action: PayloadAction<Actuality>) => {
      if (state.value) {
        if (state.value.some(actuality_group => actuality_group._id === action.payload.when)) {
          state.value = state.value.map(actuality_group => {
            if (actuality_group._id === action.payload.when) {
              if (actuality_group.actualities.some(actuality => actuality._id === action.payload._id)) {
                return {
                  ...actuality_group,
                  actualities: actuality_group.actualities.map(actuality => actuality._id === action.payload._id ? action.payload : actuality)
                }
              }
              return {
                ...actuality_group,
                actualities: actuality_group.actualities.concat(action.payload),
                count: actuality_group.count + 1
              }
            }
            return actuality_group.actualities.some(actuality => actuality._id === action.payload._id) ?
              {
                ...actuality_group,
                count: actuality_group.count - 1,
                actualities: actuality_group.actualities.filter(actuality => actuality._id === action.payload._id)
              }
              :
              actuality_group
          }).filter(actuality_group => actuality_group.actualities.length > 0)
        }
        else {
          state.value = state.value.concat({
            _id: action.payload.when,
            actualities: [action.payload],
            count: 1
          })
        }
      }
    },
    reset: (state, action: PayloadAction<ActualityGroup[] | undefined>) => {
      state.value = action.payload
    },
    setLoading: (state, action: PayloadAction<Partial<IsLoading>>) => {
      state.isLoading = {
        ...state.isLoading, ...action.payload
      }
    }
  }
})

export const { reset, pop, merge, append, setLoading } = actualitySlice.actions
export const actuality_slice = actualitySlice.reducer